import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { SchoolsService } from '../../schools/schools.service';
import { GroupDto } from '@oracychampions/api-interfaces';
import { AuthService } from '../../auth/auth.service';
import { catchError, of } from 'rxjs';
import { UsersService } from '../../users/users.service';

export const groupsResolver: ResolveFn<GroupDto[]> = (route, state) => {
  const schoolsService = inject(SchoolsService);
  const usersService = inject(UsersService);
  const auth = inject(AuthService);

  const schoolId = auth.auth$.getValue()?.user.schoolId;
  const role = auth.auth$.getValue()?.user.role;
  const userId = auth.auth$.getValue()?.user.id;

  if (!schoolId) {
    return [];
  }

  return role === 0
    ? schoolsService.getSchoolGroups(schoolId).pipe(
        catchError(() => {
          return of([]);
        }),
      )
    : usersService.getUserGroups(userId).pipe(
        catchError(() => {
          return of([]);
        }),
      );
};
